function processCafePixel(pixel_id) {
    if (!pixel_id) return;

    fbq('init', pixel_id);
    fbq('trackSingle', pixel_id, 'PageView');
}

export default {
    processCafePixel
}